module.exports = __webpack_public_path__ + "img/printLogo.cdf79ca4.png";